<template>
  <div
    id="charts"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    drawLine() {
      if (document.getElementById("charts") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("charts"));
      let myChart = this.$echarts.init(document.getElementById("charts"));
      myChart.setOption({}, true);
      let option = {
        grid: {
          top: "50px",
          left: "80px",
          right: "15px",
          bottom: "50px",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "rgba(50, 216, 205, 1)",
            },
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: 1,
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#A1A7B3",
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },

            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: `单位(kw·h)`,
            nameTextStyle: {
              color: "#A1A7B3",
              fontSize: 12,
            },
            padding: 5,
            // max: 1000,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#A1A7B3",
                type: "dashed",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              margin: 10,
              color: "#A1A7B3",
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "发电量",
            type: "line",
            smooth: true,
            stack: "总量",
            symbolSize: 5,
            showSymbol: false,
            itemStyle: {
              color: "#23D0C4",
              lineStyle: {
                color: "#23D0C4",
                width: 2,
              },
            },
            areaStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(50, 216, 205, 1)",
                  },
                  {
                    offset: 0.7,
                    color: "rgba(255, 255, 255, 0.2)",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
            data: [220, 182, 191, 234, 290, 330, 310, 201, 154, 190, 330, 410],
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {
    this.drawLine();
  },
};
</script>

<style>
</style>